export default "__VITE_ASSET__CWFoU8nS__"